import i from "./ghl-ui.es1505.js";
import h from "./ghl-ui.es1506.js";
import u from "./ghl-ui.es1514.js";
import d from "./ghl-ui.es1466.js";
function l(a, o) {
  d(2, arguments);
  var t = h(a), e = i(o), n = t.getFullYear(), m = t.getDate(), r = /* @__PURE__ */ new Date(0);
  r.setFullYear(n, e, 15), r.setHours(0, 0, 0, 0);
  var s = u(r);
  return t.setMonth(e, Math.min(m, s)), t;
}
export {
  l as default
};
